import React, { useState } from "react";
import styled from "styled-components";
import { Button, ControlLabel, FormControl, FormGroup, HelpBlock } from "components/bootstrap";
import { Spinner, ISODurationInput } from "components/common";
import useTokenTTL from "./useTokenTTL";
const StyledForm = styled.form`
  margin-top: 10px;

  &.form-inline > .form-group {
    margin-right: 10px;

    > input {
      width: 300px;
    }
  }

  .input-group {
    width: 300px;
  }
`;
const CreateTokenForm = ({
  creatingToken = false,
  disableForm = false,
  forceDefaultTtl = void 0,
  disableTtl = false,
  onCreate
}) => {
  const [tokenName, setTokenName] = useState("");
  const { tokenTtl, setTokenTtl, resetTokenTtl } = useTokenTTL(forceDefaultTtl);
  const createToken = (event) => {
    event.preventDefault();
    onCreate({ tokenName, tokenTtl });
    setTokenName("");
    resetTokenTtl();
  };
  const ttlValidator = (milliseconds) => milliseconds >= 6e4;
  return /* @__PURE__ */ React.createElement(StyledForm, { className: "form-inline", onSubmit: createToken }, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "create-token-input" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Token Name"), /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      disabled: disableForm,
      placeholder: "What is this token for?",
      value: tokenName,
      onChange: (event) => setTokenName(event.target.value)
    }
  )), !disableTtl && /* @__PURE__ */ React.createElement(
    ISODurationInput,
    {
      id: "token_creation_ttl",
      duration: tokenTtl,
      update: (value) => setTokenTtl(value),
      label: "Token TTL",
      help: "",
      validator: ttlValidator,
      errorText: "invalid (min: 1 minute)",
      disabled: disableForm,
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      id: "create-token",
      disabled: disableForm || tokenName === "" || creatingToken,
      type: "submit",
      bsStyle: "primary"
    },
    creatingToken ? /* @__PURE__ */ React.createElement(Spinner, { text: "Creating..." }) : "Create Token"
  ), /* @__PURE__ */ React.createElement(HelpBlock, null, "TTL Syntax Examples: for 60 seconds: PT60S, for 60 minutes: PT60M, for 24 hours: PT24H, for 30 days: P30D"));
};
export default CreateTokenForm;
